
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/frequent_questions",
      function () {
        return require("private-next-pages/frequent_questions/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/frequent_questions"])
      });
    }
  